const useHelper = () => {

  const isValidEmail = email =>
// eslint-disable-next-line no-useless-escape
/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
  email
);
  const isValidName   = username => /^([a-zéçèàêëùÏ]+\s[a-zéçèàêëùÏ]+)|([ء-ي]+\s[ء-ي]+)$/i.test(username);
  const isValidPass   = password => /^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z])[\w~@#$%^&*+=`|{}:;!.?()-]{8,25}$/.test(password);
  const isMatchPass   = (password, repassword) => password === repassword;
  const isValidPhone  = phoneNum => /^\+?\d{0,3}\s?0?\d?\s?\d{2,3}\s?\d{3}\s?\d{3}$/.test(phoneNum);
  const isValidTel    = phoneNum => /^\+?\d{0,3}\s?0?\d?\s?\d{2}\s?\d{3}\s?\d{3}$/.test(phoneNum);

  const isValidURL    = url => /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?$/.test(url);
  const isNotEmpty    = value =>  Array.isArray(value) ? value?.length > 0 : value !== null && value !== undefined && value !== ''; 
  
  const isValidAdress = address => /^\s*\S+(?:\s+\S+){2}/.test(address);
  const isValidNumber = number =>/^[0-9]{8}$/.test(number);
  const isValidPostal = number => /^\d{2}\s\d{3}$/.test(number);
  const isValideCNRC  = number => /^16\/[0-9]{2}\s-\s[0-9]{7}\s[AB][0-9]{2}$/.test(number);
  const isValideNIF   = number => /^[0-9]{4}\s[0-9]{4}\s[0-9]{5}\s[0-9]{2}$/.test(number);
  const isValideRIB   = number => /^[0-9\s]{15,26}$/.test(number);

  const autoSpacing   = (event, onChange) => {
    const inputValue  = event.target.value.replace(/[^\d+]/g, "");
    const pattern = inputValue.startsWith("+") ? /^(\+?\d{1,3})?(\d{0,4})?(\d{0,3})?(\d{0,3})?(\d{0,3})?$/ : /^(\d{0,4})?(\d{0,3})?(\d{0,3})?(\d{0,3})?$/
    const formatted = inputValue
      .replace(pattern, (match, p1, p2, p3, p4, p5) => {
        let formattedValue = "";
        if (p1) formattedValue += p1;
        if (p2) formattedValue += p2.length > 0 ? ` ${p2}` : "";
        if (p3) formattedValue += p3.length > 0 ? ` ${p3}` : "";
        if (p4) formattedValue += p4.length > 0 ? ` ${p4}` : "";
        if (p5) formattedValue += p5.length > 0 ? ` ${p5}` : "";
        return formattedValue;
      });
  
    onChange(formatted);
  };

  const autoSpacingFix = (event, onChange) => {
    const inputValue = event.target.value.replace(/[^\d+]/g, "");

    const formatted = inputValue
      .replace(/^(\+?\d{1,3})?(\d{0,3})?(\d{0,3})?(\d{0,3})?$/, (match, p1, p2, p3, p4) => {
        let formattedValue = "";
        if (p1) formattedValue += p1;
        if (p2) formattedValue += p2.length > 0 ? ` ${p2}` : "";
        if (p3) formattedValue += p3.length > 0 ? ` ${p3}` : "";
        if (p4) formattedValue += p4.length > 0 ? ` ${p4}` : "";
        return formattedValue;
      });

    onChange(formatted);
  };

  const validationFunctions = {
    isValidEmail : email =>isValidEmail(email),
    isValidName   : username => isValidName(username),
    isValidPass   : password => isValidPass(password),
    isMatchPass   : (password, repassword) => isMatchPass(password, repassword),
    isValidPhone  : phoneNum => isValidPhone(phoneNum),
    isValidTel    : phoneNum => isValidTel(phoneNum),
    isValidPostal : number =>isValidPostal(number),
    isValidURL    : url => isValidURL(url),
    isNotEmpty    : array => isNotEmpty(array),
    isValidAdress : address => isValidAdress(address),
    isValidNumber : number =>isValidNumber(number),
    isValideCNRC  : number => isValideCNRC(number),
    isValideNIF   : number => isValideNIF(number),
    isValideRIB   : number => isValideRIB(number)
  }

  return {isValidEmail, isValidPass, isValidName, isValidPhone, isValidTel, autoSpacing, autoSpacingFix,
          isNotEmpty, isValidAdress, isMatchPass, isValidNumber,isValidPostal,
          isValidURL, isValideCNRC, isValideNIF, isValideRIB, validationFunctions
        }
}

export default useHelper